import React from 'react'
import { useTranslation } from 'react-i18next'
import Text from '@navent-jobs/ui-kit/components/text'
import { ButtonPerfilEmpresa } from '../../mixins'
import { getCompanyURL } from '../../../../../../../hooks/get-company-url'

const Component = ({ empresa }) => {
  const { t } = useTranslation()

  const settingsCompanyURL = getCompanyURL({ company: empresa })

  return (
    <ButtonPerfilEmpresa
      {...settingsCompanyURL}
      linkoptions={{
        size: 'medium',
        variant: 'primary',
        type: 'outline',
        native: false,
        target: '_blank',
      }}
    >
      <Text size="md" fontWeight="semibold" variant="primary">
        {t('fichaAviso.sections.empresa.verMasAvisos')}
      </Text>
    </ButtonPerfilEmpresa>
  )
}

export default Component
